import { rafDebounce } from '../../utils';

const VehicleInfos = () => {
  const infos = document.querySelector('.js-vehicleInfos');
  const header = document.querySelector('.js-heroVehicle');

  if (infos && header) {
    const maskContainer = document.createElement('div');
    const mask = document.createElement('div');

    const handler = () => {
      const infosBox = infos.getBoundingClientRect();
      const headerBox = header.getBoundingClientRect();
      const overlap = Math.max(0, Math.min(infosBox.bottom - headerBox.bottom, infosBox.height));

      if (overlap !== mask.clientHeight) {
        mask.style.height = `${overlap}px`;
      }
    };

    const debouncedHandler = rafDebounce(handler);

    maskContainer.classList.add('m-vehicleInfos__mask-container');
    mask.classList.add('m-vehicleInfos__mask');
    maskContainer.append(mask);
    infos.prepend(maskContainer);

    document.addEventListener('readystatechange', (event) => {
      if (event.target.readyState === 'complete') {
        document.addEventListener('scroll', debouncedHandler);
        handler();
      }
    });

    window.addEventListener('resize', debouncedHandler);
  }
};

export default VehicleInfos;
